import React from "react";
import { Airplane, MapPin, Car } from "@phosphor-icons/react";

// Simulated grayscale map with a route between airport and destination.
// progress: 0-100 position of the driver marker along the route.
export default function MockMap({ progress = 0, label = "", showCar = true }) {
  const p = Math.max(0, Math.min(100, progress));
  const x = 40 + (p / 100) * 480;
  const y = 240 - (p / 100) * 150 + Math.sin(p / 12) * 14;
  return (
    <div className="relative w-full h-full bg-[#EDEDED] overflow-hidden" data-testid="mock-map">
      <svg viewBox="0 0 560 300" className="w-full h-full" preserveAspectRatio="xMidYMid slice">
        <rect width="560" height="300" fill="#E7E7E7" />
        {Array.from({ length: 14 }).map((_, i) => (
          <line key={"v" + i} x1={i * 42} y1="0" x2={i * 42} y2="300" stroke="#DADADA" strokeWidth="1" />
        ))}
        {Array.from({ length: 8 }).map((_, i) => (
          <line key={"h" + i} x1="0" y1={i * 42} x2="560" y2={i * 42} stroke="#DADADA" strokeWidth="1" />
        ))}
        <path d="M-20 210 L200 150 L360 200 L620 120" stroke="#CFCFCF" strokeWidth="14" fill="none" />
        <path d="M120 -20 L180 160 L140 320" stroke="#CFCFCF" strokeWidth="10" fill="none" />
        <rect x="380" y="60" width="90" height="60" fill="#DDE7DD" />
        <rect x="60" y="200" width="120" height="70" fill="#DDE3EC" />
        {/* route */}
        <path d="M40 240 C 180 180, 340 260, 520 90" stroke="#0B1533" strokeWidth="3" fill="none" className="route-line" />
        <circle cx="40" cy="240" r="7" fill="#EF5A1E" />
        <circle cx="520" cy="90" r="7" fill="#0B1533" />
        {showCar && (
          <g>
            <circle cx={x} cy={y} r="18" fill="#EF5A1E" opacity="0.25" className="pulse-ring" style={{ transformOrigin: `${x}px ${y}px` }} />
            <circle cx={x} cy={y} r="9" fill="#EF5A1E" stroke="#fff" strokeWidth="2.5" />
          </g>
        )}
      </svg>
      <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-md border border-[#E5E5E5] px-3 py-1.5">
        <Airplane size={14} weight="fill" />
        <span className="font-body text-xs font-semibold">ZRH</span>
      </div>
      <div className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-md border border-[#E5E5E5] px-3 py-1.5">
        <MapPin size={14} weight="fill" />
        <span className="font-body text-xs font-semibold">{label}</span>
      </div>
      {showCar && (
        <div className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-[#0B1533] px-3 py-1.5">
          <Car size={14} weight="fill" color="#fff" />
          <span className="font-body text-xs font-semibold text-white">{Math.round(p)}%</span>
        </div>
      )}
    </div>
  );
}
